var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centerTopContainer"},[_c('div',{staticClass:"topTitle"},[_vm._v("累计服务人次")]),_c('div',{staticClass:"topPlate"},[_c('light-plate',{attrs:{"lightNum":_vm.serviceNum}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }